export default "__VITE_ASSET__Cc7HNPx8__"